/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { InstallMethod, Technology } from '../../constants/installation';
import type { EditorPlugins } from '../../types/EditorPlugins';

export function requiresExportCss( {
	editorPlugins,
	selectedTechnology,
	selectedInstallMethod
}: {
	editorPlugins: EditorPlugins;
	selectedTechnology: Technology;
	selectedInstallMethod: InstallMethod;
} ): boolean {
	// In case of Vanilla JS build, only the npm build requires export css file.
	if ( selectedTechnology === 'js' && selectedInstallMethod !== 'npm' ) {
		return false;
	}

	return editorPlugins.some( pluginClassName => [ 'ExportPdf', 'ExportWord' ].includes( pluginClassName ) );
}
